import React from 'react';
import { useSelector } from 'react-redux';

import SimpleLoader from './SimpleLoader';

const AppLoader = () => {
  const { type, message } = useSelector((state) => state.ui.loaderStatus);

  const renderLoader = () => {
    switch (type) {
      case 'init':
        return <SimpleLoader />;
      case 'simple':
        return <SimpleLoader transparent />;
      case 'message':
        return <SimpleLoader message={message} />;
      case 'success':
        return <SimpleLoader message={message} success />;
      default:
        return '';
    }
  };

  return (
    <div className="app-loader">
      {renderLoader()}
    </div>
  );
};

export default AppLoader;
